module.exports = __webpack_public_path__ + "img/ic_nat_home_hsyy_01.097e630d.png";